import { render, staticRenderFns } from "./T1HotelAttributesPlaceholder.vue?vue&type=template&id=fad6b61c&scoped=true&"
var script = {}
import style0 from "./T1HotelAttributesPlaceholder.vue?vue&type=style&index=0&id=fad6b61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad6b61c",
  null
  
)

export default component.exports